import React from "react";
import mediumImage1 from "../../../../assets/Blogs/medium_image_1.png";
import mediumImage2 from "../../../../assets/Blogs/medium_image_2.png";
import mediumImage3 from "../../../../assets/Blogs/medium_image_3.png";
import mediumImage4 from "../../../../assets/Blogs/medium_image_4.png";

const Blog5 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          This Article is a Consolidation of our Past 1 year of Learning to
          Build an Approximate Product market fit MVP(Minimum Viable Product).
          We have made a lot of mistakes and made a lot of pivots. If you can
          learn something from our mistakes it might save you some precious
          time!
        </p>

        <p className="paragraph-content">
          Some things which we worked on were-
        </p>

        <ol style={{ listStyle: "none", paddingLeft: 0 }}>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • Idea Identification
          </li>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • Unique Proposition for the user
          </li>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • User Acquisition
          </li>
        </ol>

        <img src={mediumImage1} alt="Description of image" />

        <p className="paragraph-content">
          P.S.- These are Some Standard Business assessment questions which we
          followed.
        </p>

        <p className="paragraph-content">
          <i>
            Also if you're having an Application or Website or anything related
            to tech which you want to showcase. make sure you are always updated
            with the current trends and tools in the tech space. which would
            make things simpler for both you and the development team.
          </i>
        </p>

        <p className="paragraph-content">
          Techstack and Tools are as Important as the Idea.
        </p>

        <img src={mediumImage2} alt="Description of image" />

        <p className="paragraph-content">
          The Tech which we have used to superpower our Application are
          mentioned. make sure you have room for scalability and make sure you
          have the security of the user at the centre of building an
          application.
        </p>

        <p className="paragraph-content">
          So We started with Deconstructing the Idea-
        </p>

        <p className="paragraph-content">Questions which we asked ourselves-</p>

        <ol style={{ listStyle: "none", paddingLeft: 0 }}>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • Is this App really needed?
          </li>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • Why will the user switch the application?
          </li>
          <li style={{ marginBottom: "10px", color: "black" }}>
            • What's the feature which would keep the user hooked to our app?
          </li>
        </ol>

        <p className="paragraph-content">
          So When we were answering the questions it made us think twice on, Is
          it really required what we were building? We immediately opened up the
          mood board and started brainstorming on why is this particular
          application needed.
        </p>

        <p className="paragraph-content">
          We then started answering what the unique proposition we are offering
          to users is and why will a user switch from one application to our
          app? We conducted extensive research, reached a conclusion, and began
          putting together a plan to get into the market, which entails
          finalising our MVP.
        </p>

        <p className="paragraph-content">
          Once we got the USP of our APP it was our Goal in order to source
          methods to acquire users.
        </p>

        <img src={mediumImage3} alt="Description of image" />

        <p className="paragraph-content">
          P.S.- Sharing this one piece of user Acquisition. this is just one
          part in order to acquire the user there are many ways to acquire a
          user.
        </p>

        <p className="paragraph-content">
          We were on track and things were going very smoothly for us. until we
          got feedback. whatever we had built was very good for a short
          term(Short span of time) there was a clear indication that our
          Application is very useful for a very short span of time.
        </p>

        <p className="paragraph-content">We failed,</p>

        <p className="paragraph-content">
          We came back to our Approach the Biggest thing which we missed was.
          Getting Actual User feedback and User input for the Product.
        </p>

        <p className="paragraph-content">
          We were only thinking from a business POV and not from a customer's
          POV. We also conducted user interviews, something we didn’t do during
          the idea construction process.
          <br />
          Consequently, we built our concepts around the problems and needs of
          the user to arrive at our Unique Proposition for the user.
        </p>

        <p className="paragraph-content">
          If you want your idea to succeed, you should have a strategy for user
          acquisition and a marketing roadmap. Always Keep the user at the
          centre when you're building.
        </p>

        <img src={mediumImage4} alt="Description of image" />

        <p className="paragraph-content">
          Lots of Changes in the design we had when we were asking for feedback,
          user interpretations and A/b testing. The Design Piece would be
          covered by our Design team in Depth which would be covering on what
          things you need to take care of while designing something.
        </p>

        <p className="paragraph-content">
          We had a lot of hurdles while building the app there were lots of ups
          and downs to reach till MVP. Many people say building an MVP is the
          easiest task. what they don't look at is compliance, Data Security and
          user experience.
        </p>

        <p className="paragraph-content">
          So Just make sure that you consistently keep trying and always try to
          think out of the box. we had lots of learning.
        </p>

        <p className="paragraph-content">
          So this concludes our Journey from <b>IDEA</b> to <b>MVP!</b>
        </p>

        <p className="paragraph-content">
          You can have a look at this link:
          <a
            href="https://kleiolabs.notion.site/About-Kleio-K-Pay-f538b15547c947f7b2f52871b1ead23a"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1155cc", textDecoration: "underline" }}
          >
            About Kleio K-Pay
          </a>
        </p>

        <p className="paragraph-content">
          P.S.- Would like to Thank my Team members, My Family and my Friends
          for providing constant motiviation to us to build the Application.
        </p>
      </div>
    </div>
  );
};

export default Blog5;
